import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { HistoryHebrewItem, HistoryItemAgent, RawHistoryItemAddress } from 'store/state/selectors/insights/prices';
import * as Styled from './styled';
import AffiliationTile from 'components/widget/prices/prices-table/tables/history/affiliation/AffiliationTile';
import { DealAffiliationType, IRequestDealAffiliationResponse } from 'utils/entities';
import { dealAffiliationRequestsBySaleIdLoadingSelector, pendingUserDealAffiliationRequestsBySaleIdSelector } from 'store/state/domainData/selectors/getDealsAffiliationRequests';
import Spinner from 'components/widget/prices/prices-table/tables/history/affiliation/Spinner';
import { agentIdSelector } from 'store/state/domainData/selectors';


interface AffiliationSectionProps {
  address: RawHistoryItemAddress;
  dealAffiliationRequests: IRequestDealAffiliationResponse[];
  dealAffiliationRequestsLoading: boolean;
  hideAffiliationButton?: boolean;
  item: HistoryHebrewItem;
  buyer: HistoryItemAgent | null;
  seller: HistoryItemAgent | null;
}

const AffiliationSection: React.FC<AffiliationSectionProps> = ({
  address,
  dealAffiliationRequests,
  dealAffiliationRequestsLoading,
  hideAffiliationButton,
  item,
  buyer,
  seller,
}) => {
  if (dealAffiliationRequestsLoading && !hideAffiliationButton) return <Spinner />;

  const requested = dealAffiliationRequests && dealAffiliationRequests.length > 0;
  const requestedSeller = requested && dealAffiliationRequests.findIndex(dar => dar.agentType === DealAffiliationType.Seller) !== -1;
  const requestedBuyer = requested && dealAffiliationRequests.findIndex(dar => dar.agentType === DealAffiliationType.Buyer) !== -1;
  const requestedBothSides = requested && dealAffiliationRequests.findIndex(dar => dar.agentType === DealAffiliationType.Both) !== -1;

  let content;

  if (!buyer && !seller && !requested) {
    content = hideAffiliationButton ? null : (
      <AffiliationTile address={address} item={item} requested={requested} />
    );
  }
  else if (!buyer && !seller && requestedBothSides) {
    content = hideAffiliationButton ? null : (
      <AffiliationTile address={address} affiliationSide={DealAffiliationType.Both} item={item} requested={requested} />
    );
  }
  else if (buyer && seller && buyer.agentId === seller.agentId) {
    content = (
      <AffiliationTile
        address={address}
        affiliatedAgent={buyer}
        affiliationSide={DealAffiliationType.Both}
        item={item}
        requested={requested}
      />
    );
  }
  else {
    content = (
      <>
        {hideAffiliationButton && !seller ? null : (
          <AffiliationTile
            address={address}
            affiliatedAgent={seller}
            affiliationSide={DealAffiliationType.Seller}
            item={item}
            requested={requestedSeller}
          />
        )}
        {hideAffiliationButton && !buyer ? null : (
          <AffiliationTile
            address={address}
            affiliatedAgent={buyer}
            affiliationSide={DealAffiliationType.Buyer}
            item={item}
            requested={requestedBuyer}
          />
        )}
      </>
    );
  }

  return <Styled.AffiliationSectionRoot>{content}</Styled.AffiliationSectionRoot>;
};

const mapStateToProps = (state: State) => ({
  agentId: agentIdSelector(state),
  dealAffiliationRequests: pendingUserDealAffiliationRequestsBySaleIdSelector(state),
  dealAffiliationRequestsLoading: dealAffiliationRequestsBySaleIdLoadingSelector(state),
});

export default connect(mapStateToProps, null)(AffiliationSection);
